import {Mapper} from '@s-ui/domain'

export default class ContractRawDataToContractEntityDealerMapper extends Mapper {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Object} deps.config
   * @param {Function} deps.entityFactory
   */
  constructor({config, entityFactory}) {
    super({config, entityFactory})
    this._config = config
    this._entityFactory = entityFactory

    const {PRIVATE_CONTRACT_ID} = this._config.get('dealer')
    this._privateContractId = PRIVATE_CONTRACT_ID
  }

  _getContractType({id = this._privateContractId} = {}) {
    const isProfessional = Number(id) > this._privateContractId
    const isPrivate = this._privateContractId === Number(id)

    return {
      isPrivate,
      isProfessional
    }
  }

  /**
   * @param {Object} params
   * @param {Number|String} params.contractId
   * @returns {ContractEntity}
   */
  map({contractId} = {}) {
    const id = contractId

    return this._entityFactory({
      id,
      ...this._getContractType({id})
    })
  }
}
